import PageLayout from "../../components/feature/PageLayout";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import YokohamaFeature from "./components/YokohamaFeature";
import ScenesSection from "./components/ScenesSection";
import PlansSection from "./components/PlansSection";
import StepsSection from "./components/StepsSection";
import StrengthsSection from "./components/StrengthsSection";
import SafetySection from "./components/SafetySection";
import ReviewsSection from "./components/ReviewsSection";
import FAQPreview from "./components/FAQPreview";
import GiftSection from "./components/GiftSection";
import AccessSection from "./components/AccessSection";
import ColumnSection from "./components/ColumnSection";
import AreasSection from "./components/AreasSection";
import FinalCTA from "./components/FinalCTA";

export default function Home() {
  return (
    <PageLayout>
      <HeroSection />
      <AboutSection />
      <YokohamaFeature />
      <ScenesSection />
      <PlansSection />
      <StepsSection />
      <StrengthsSection />
      <SafetySection />
      <ReviewsSection />
      <FAQPreview />
      <GiftSection />
      <AccessSection />
      <ColumnSection />
      <AreasSection />
      <FinalCTA />
    </PageLayout>
  );
}